var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMamily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 10.6992C0.324219 5.17637 4.80137 0.699219 10.3242 0.699219H38.3242C43.8471 0.699219 48.3242 5.17637 48.3242 10.6992V38.6992C48.3242 44.2221 43.8471 48.6992 38.3242 48.6992H10.3242C4.80137 48.6992 0.324219 44.2221 0.324219 38.6992V10.6992Z",
    fill: "url(#paint0_linear_4168_5906)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3242 28.6992C22.8242 28.9992 23.5242 29.1992 24.3242 29.1992C25.1242 29.1992 25.8242 28.9992 26.3242 28.6992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3242 24.6992H27.3342",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7028 19.5122C32.4039 20.5316 32.8873 21.6846 33.1228 22.8992C33.4609 23.063 33.7461 23.3187 33.9456 23.637C34.1451 23.9554 34.251 24.3235 34.251 24.6992C34.251 25.0749 34.1451 25.443 33.9456 25.7614C33.7461 26.0797 33.4609 26.3354 33.1228 26.4992C32.691 28.5127 31.5819 30.3172 29.9804 31.6117C28.379 32.9063 26.382 33.6124 24.3228 33.6124C22.2635 33.6124 20.2665 32.9063 18.6651 31.6117C17.0636 30.3172 15.9545 28.5127 15.5228 26.4992C15.1846 26.3354 14.8994 26.0797 14.6999 25.7614C14.5004 25.443 14.3945 25.0749 14.3945 24.6992C14.3945 24.3235 14.5004 23.9554 14.6999 23.637C14.8994 23.3187 15.1846 23.063 15.5228 22.8992C15.937 20.8697 17.0386 19.0452 18.6418 17.7336C20.2449 16.4219 22.2514 15.7034 24.3228 15.6992C26.3228 15.6992 27.8228 16.7992 27.8228 18.1992C27.8228 19.5992 26.9228 20.6992 25.8228 20.6992C25.0228 20.6992 24.3228 20.2992 24.3228 19.6992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3242 24.6992H21.3342",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5906",
    x1: 24.3242,
    y1: 0.699219,
    x2: 24.3242,
    y2: 48.6992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMamily);
export default __webpack_public_path__ + "static/media/mamily.7fbeebf03317416700d6c8a79d158a37.svg";
export { ForwardRef as ReactComponent };